import React, { useEffect, useState } from "react";
import { getShipment } from "../api";
import { ActiveLoadCard, PostedCard } from "../components/Cards";
import Error from "../components/Error";
import Loading from "../components/Loading";
import { ShipmentStatus } from "../utils/enums";

export default function Home() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const shipmentId = urlParams.get("shipmentId");

    if (!shipmentId) {
      setError("Shipment Id missing");
      setLoading(false);
      return;
    }

    setError(null);

    getShipment(shipmentId)
      .then(data => {
        setData(data);
      })
      .catch(err => {
        setError(err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (error !== null) {
    return <Error subTitle={error} />;
  }

  if (data.status === ShipmentStatus.Posted) {
    return (
      <PostedCard
        pickupAddress={data.pickupAddress}
        dropOffAddress={data.dropOffAddress}
        vehicles={data.vehicles}
      />
    );
  }

  return (
    <ActiveLoadCard
      shipmentStatus={data.status}
      loadStatus={data.loadStatus}
      vehicles={data.vehicles}
      pickupAddress={data.pickupAddress}
      dropOffAddress={data.dropOffAddress}
      loadLocation={data.location}
      loadPickUpETA={data.loadPickupETA}
      loadPickUpETATimeSlot={data.loadPickupETATimeSlot}
      loadDropOffETA={data.loadDropOffETA}
      loadDropOffETATimeSlot={data.loadDropOffETATimeSlot}
      driverData={{
        driverName: data.driverName,
        driverPhoneNumber: data.driverPhoneNumber,
        driverPhoneExtension: data.driverPhoneExtension,
        transporterName: data.transporterName,
      }}
    />
  );
}
